import * as EventConstants from 'constants/EventConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import AppDispatcher from 'lib/Dispatcher';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

import {LOADING_SCREEN, Screen} from './FullScreenConstants';
import FullScreenStore from './FullScreenStore';

export function showScreen(screen: Screen): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SHOW_FULL_SCREEN,
    screen,
  });
  SidepanelActions.close({autoOpenFile: false});
}

export function showLoadingScreen(): void {
  showScreen(LOADING_SCREEN);
}

export function hideScreen(): void {
  AppDispatcher.dispatch({actionType: EventConstants.HIDE_FULL_SCREEN});
}

export function hideScreenForRouting(): void {
  // TODO(T7269): Remove this when we move routing/state to one centralized place
  if (FullScreenStore.getCurrentScreen()) {
    FileBrowserActions.openDefaultHomeState();
  }
  hideScreen();
}
